if (!customElements.get('video-controller')) {
  class VideoController extends HTMLElement {
    constructor() {
      super();
      let paused = false;
      this.addEventListener('click', (event) => {
        this.handleClick(event);
      });
    }
    handleClick() {
      const video = this.nextElementSibling;
      if (video.paused) {
        video.play();
        this.style.opacity = 0;
        this.paused = false;
      } else {
        video.pause();
        this.style.opacity = 1;
        this.paused = true;
      }
    }
  }
  customElements.define('video-controller', VideoController);
}
